<p-button icon="pi pi-copy" [ariaLabel]="'Copy ' + label()" (onClick)="onClick()">
</p-button>
